<div class="card my-3">
    <div class="card-header d-inline-flex">
        <a href="/" class="btn btn-sm btn-outline-secondary" title="Back to Dashboard"><i
                class="bi bi-backspace"></i></a>
        <h5 class="card-title ms-2" id="examplecardLabel">Delete Event</h5>
    </div>
    <div class="card-body">

        <label class="form-label" for="artTitle">
            This event can no longer be recovered once deleted. Continue?
        </label>

        <div class="d-grid gap-2">
            <a class="btn btn-secondary" href="/">Cancel</a>
            <a class="btn btn-info" href="/edit-event/{{id}}">Review and Edit</a>
            <button type="button" (click)="delete()" class="btn btn-danger">Delete Event</button>
        </div>


    </div>
</div>